import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [open, setOpen] = useState(false);

  return (
    <section className="py-12 md:py-16" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
      <div className="section-container">
        <div className="max-w-md mx-auto">
          <h2 className="font-heading font-semibold text-xl md:text-2xl text-center mb-2 text-foreground-950">
            Browse Product Categories
          </h2>
          <p className="text-sm text-center mb-6 text-foreground-600">
            Select a category to explore our full collection on VigorBuy Spreadsheet
          </p>

          <div className="relative">
            <button
              onClick={() => setOpen(!open)}
              className="w-full flex items-center justify-between px-5 py-3.5 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer"
              style={{
                backgroundColor: 'oklch(var(--background-50))',
                border: '1px solid oklch(var(--background-300))',
                color: 'oklch(var(--foreground-900))',
              }}
            >
              <span>{open ? 'Choose a category...' : 'Select a product category'}</span>
              <i className={`${open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-lg transition-transform duration-200`} style={{ color: 'oklch(var(--foreground-500))' }}></i>
            </button>

            {open && (
              <div
                className="absolute top-full left-0 right-0 mt-1 rounded-lg overflow-hidden z-30 max-h-[320px] overflow-y-auto"
                style={{
                  backgroundColor: 'oklch(var(--background-50))',
                  border: '1px solid oklch(var(--background-300))',
                }}
              >
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="block w-full text-left px-5 py-3 text-sm transition-colors duration-150 cursor-pointer hover:bg-accent-50 text-foreground-700"
                    onClick={() => setOpen(false)}
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}